<template lang="html">
  <div class="fixed">
    <h2>Estimation de votre projet</h2>
    <div class="recap">
      <router-link to="#materiaux">Matériau</router-link>
      <span>{{$store.state.devis[0].coloris}} {{($store.state.devis[0].finition == 'mat')?'mat':'satiné'}} ({{$store.state.devis[0].group}})</span>
    </div>
    <div class="recap">
      <router-link to="#taille-plan">Taille de votre plan</router-link>
      <div class="flex-element"  v-for="(p, index) in $store.state.devis[6].plans">
           {{p.lng}} mm x {{p.lrg}} mm x 12mm
           <span class="price">{{p.beautifulPrice}}€</span>
      </div>
    </div>
    <div class="recap">
      <router-link to="#epaisseur-chant">Épaisseur du chant</router-link>
      <div class="flex-element">
        {{$store.state.devis[2].longueur}}mm {{chants[$store.state.devis[2].chant].name}}
        <span class="price">{{beautify($store.state.devis[2].longueur * chants[$store.state.devis[2].chant].price)}} €</span>
      </div>
    </div>
    <div class="recap">
      <router-link to="#taille-credence">Taille de votre crédence</router-link>
      <div class="flex-element"  v-for="(c, index) in $store.state.devis[7].credences">
           {{c.lng}} mm x {{c.lrg}} mm x 12mm
           <span class="price">{{c.beautifulPrice}}€</span>
      </div>
    </div>
    <div class="recap">
      <router-link to="#options">Options et découpe</router-link>
        <div v-for="o in $store.state.devis[4].options" v-if="o.quantity > 0" class="flex-element">
          {{o.quantity}}x {{options[o.id].name}}
          <span class="price">{{beautify(options[o.id].price * o.quantity)}} €</span>
        </div>
    </div>
    <div class="recap">
      <router-link to="#services">Services</router-link>
        <div v-for="s in $store.state.devis[5].services" v-if="s.selected" class="flex-element">
          {{services[s.id].name}}
          <span class="price">{{beautify(services[s.id].price)}} €</span>
        </div>
    </div>
    <div class="total">
      <div class="total_ht">
         <b>TOTAL HT</b>
         {{beautify($store.state.price)}} €
      </div>
      <div class="tva">
         <b>TVA {{ $store.state.tva }}%</b>
         {{beautify( $store.state.price * $store.state.tva / 100 )}} €
      </div>
      <div class="total_ttc">
         <b>TOTAL TTC</b>
         {{beautify( $store.state.price + ($store.state.price * $store.state.tva / 100) )}} €
      </div>

    </div>
  </div>
</template>

<script>
import {options, services, chants, groups} from '../../assets/configuration.js'

export default {
  data () {
    return {
      options,
      groups,
      services,
      chants,
      showOptions: false,
      showServices: false
    }
  },
  methods: {
    beautify (price) {
      return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }
}
</script>

<style lang="css" scoped>
h2 {
  margin: 0;
  margin-bottom: 20px;
  color: #000;
}
.recap {
  margin-bottom: 10px;
}
.recap a {
  display:block;
  font-weight: bold;
  text-decoration: none;
  color: #4e4e4e;
}

.total {
  font-size: 18px;
  font-weight: bold;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid;
}
.total > div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.not-selected {
  color: grey;
}
.flex-element {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

</style>



// WEBPACK FOOTER //
// Price.vue?0dafbe4a